import { render, staticRenderFns } from "./base-price-station-config-list.vue?vue&type=template&id=2fd3b6e0&scoped=true&"
import script from "./base-price-station-config-list.vue?vue&type=script&lang=js&"
export * from "./base-price-station-config-list.vue?vue&type=script&lang=js&"
import style0 from "./base-price-station-config-list.vue?vue&type=style&index=0&id=2fd3b6e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd3b6e0",
  null
  
)

export default component.exports